import {Component, OnInit} from '@angular/core';
import {Customer} from '../../../dto/customer';
import {toDateString} from '../../../providers/app-date-adapter';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {CustomersService} from '../../services/customers.service';
import {Location} from '@angular/common';
import {CardsService} from '../../services/cards.service';
import {EventLogService} from '../../../services/crud/event-log.service';
import {ObjectComment} from '../../../dto/object-comment';
import {ObjectCommentsService} from '../../services/object-comment.service';
import {RoleService} from '../../../services/role.service';
import {OrdersService} from '../../services/orders.service';
import {IdentLevel, IdentStatus} from '../../../dto/ident-status';
import {WebIdTransaction} from '../../../dto/web-id-transaction';
import {WebIdTransactionService} from '../../services/webid-transaction.service';
import {FileHelper} from '../../../helpers/file-helper';
import {Order} from '../../../dto/order';
import {Country} from '../../../dto/country';
import {CountryService} from '../../../services';
import {FormBuilder} from '@angular/forms';
import {ProductService} from '../../services/product.service';
import {InvoicesService} from '../../services/invoices.service';
import {PrevNextModel} from '../../../models/prev-next-model';
import {getTableFilters} from '../../../helpers/storage-helper';

import {SendUploadLinkDialogComponent} from '../../../shared/send-upload-link/send-upload-link-dialog.component';
import {SendUploadLinkModel} from '../../../models/send-upload-link-model';
import {IdvUploadDto} from '../../../dto/idv-upload';
import {IdvCustomersService} from '../../services/idv-customers.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {CustomerIdvDocsStatusDto} from '../../../dto/customer-idv-docs-status';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {BadgeService} from '../../services/badge.service';
import {BankTransferLoad} from '../../../dto/bankTransferLoad';
import {ShowDialogWithLinkComponent} from '../../../shared/show-dialog-with-link/show-dialog-with-link.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {PepStatus} from '../../../dto/pep-status';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {ToastService} from 'angular-toastify';
import {byNumeric} from 'iso-country-codes';
import {CityInfo} from '../../../dto/GeoIp/city-info';
import {GeoIpService} from '../../../services/geo-ip.service';
import {getIdentStatusColor, getIdentStatusIcon, getIdentStatusText} from "../../../helpers/pep-status-helper";


@Component({
  selector: 'app-idv-customer-overview-detail',
  templateUrl: './idv-customer-overview-detail.component.html',
  styleUrls: ['./idv-customer-overview-detail.component.css']
})




export class IdvCustomerOverviewDetailComponent implements OnInit {

  identStatus = IdentStatus;
  pepStatus = PepStatus;

  customerId: number;
  idvUploadFiles: IdvUploadDto[];
  docsUploadFiles: IdvUploadDto[];
  sofSingleUploadFiles: IdvUploadDto[];
  sofGenericUploadFiles: IdvUploadDto[];
  openBankTransferLoads: BankTransferLoad[];
  prevNext: PrevNextModel;
  customer: Customer;
  isFrameHidden = true;
  isImgHidden = true;
  filename = null;
  errorMsg = null;

  comments: ObjectComment[];
  commentsTarget = 1;

  orders = [];

  urlSafe: SafeResourceUrl;

  ordersFields = [
    {header: 'Order ID', cell: (row: Order) => `${row.id || ''}`},
    {
      header: 'Ident',
      cell: (row: Order) => `${IdentStatus[(row.webIdTransaction || ({} as WebIdTransaction)).status] || 'not required'}`
    },
    {header: 'Order date', cell: (row: Order) => `${toDateString(row.orderDate) || ''}`},
    {header: 'Shipping date', cell: (row: Order) => `${toDateString(row.shippedDate) || ''}`},
    {header: 'Status', cell: (row: Order) => `${row.statusName || ''} `},
    {
      header: 'Cancellation Status', cell: (row: Order) => {
        if (row.cancellationStatus != null && row.cancellationStatus == 1) {
          return 'Pending';
        }
        if (row.cancellationStatus != null && row.cancellationStatus == 2) {
          return 'Done';
        }
        return '-';

      }
    },

    //{ header: "WebID status", cell: ( row: number ) => `${ WebIdTransactionStatus[(this.orders[row].order.webIdTransaction || ({} as WebIdTransaction)).status] || "WebID Was not required" }` },
    //{ header: "Response File", cell: ( row: number ) => `${ (this.orders[row].order.webIdTransaction || ({} as WebIdTransaction)).responseFileId || "No File Yet" }`, type: "button" },
  ];
  ipCityInfo: CityInfo|null;


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private customersService: CustomersService,
    private idvCustomersService: IdvCustomersService,
    private roleService: RoleService,
    private snackBar: MatSnackBar,
    private objectCommentsService: ObjectCommentsService,
    private dialog: MatDialog,

    public sanitizer: DomSanitizer,
    private badgeService: BadgeService,
    private _toastService: ToastService,
    private geoIpService: GeoIpService,

  ) { }

  fields = [
    { header: 'Link', icon: (row: Customer) => 'visibility', link: (row: Customer) => '../../customers-overview/' + (row.id || ''), cell: (row: Customer) => `Customer` } as ContentRowField<Customer>,
    {
      header: 'Ident',
      iconColor: row => getIdentStatusColor(row.identStatus),
      icon: (row: Customer) => getIdentStatusIcon(row.identStatus),
      cell: row => getIdentStatusText(row.identStatus),
    } as ContentRowField<Customer>,
    { header: 'Ident Date', cell: (row: Customer) => `${toDateString(row.identifiedDate) || ''}` } as ContentRowField<Customer>,
    { header: 'Name', cell: (row: Customer) => `${row.title} ${row.firstName} ${row.lastName}` } as ContentRowField<Customer>,
    /*{ header: "Title", cell: (row: Customer) => `${row.title}` },
    { header: "First name", cell: (row: Customer) => `${row.firstName || ""}` },
    { header: "Last name", cell: (row: Customer) => `${row.lastName || ""}` },*/
    { header: 'Address', cell: (row: Customer) => `${row.address || ''}, ${row.zipCode || ''} ${row.city || ''}` } as ContentRowField<Customer>,
    { header: 'Country', cell: (row: Customer) => `${row.countryName || ''}` } as ContentRowField<Customer>,
    /*{ header: "Address", cell: (row: Customer) => `${row.address || ""}` },
    { header: "City", cell: (row: Customer) => `${row.city || ""}` },
    { header: "Zip code", cell: (row: Customer) => `${row.zipCode || ""}` },*/
    { header: 'Email', cell: (row: Customer) => `${row.email || ''}` } as ContentRowField<Customer>,
    { header: 'Mobile', cell: (row: Customer) => `+${row.phone || ''}` } as ContentRowField<Customer>,
    { header: 'Date of birth', cell: (row: Customer) => `${toDateString(row.dob) || ''}` } as ContentRowField<Customer>,

    {header: 'IP Address', cellFlag: (row: Customer) => this.ipCityInfo?.countryAlphaIsoCode || null
      , cell: (row: Customer) => {
        const ret = row.ipAddress || '';
        if ( ret && this.ipCityInfo ) {
          //ret += " (" + this.ipCityInfo.postCode + " " + this.ipCityInfo.city + " " + this.ipCityInfo.countryName + ")"
        }
        return ret;

      }} as ContentRowField<Customer>,
    { header: 'Subscribed to news', cell: (row: Customer) => `${row.subscribeToNews ? 'Yes' : 'No' || ''}` } as ContentRowField<Customer>,

  ] as ContentRowField<Customer>[];



  ngOnInit() {

    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      this.customerId = idParam;
      this.clearData();
      this.refreshCustomer();
      this.getPrevNext(idParam);

      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl('');

    });



  }

  // search: sdkjfhsdlkufhgsdf
  createInternalDocsLink(customer) {

    this.dialog.open(ConfirmDialogComponent, { data: { title: 'Upload Docs', text: 'Are you sure you want to upload DOC files to this customer?' } })
      .afterClosed()
      .subscribe(result => {
        if (result == 'ok') {
          const model = new SendUploadLinkModel();
          model.customerId = customer.id;
          model.typeId = 2;
          model.email = null;
          model.isInternal = true;

          this.customersService.createInternalUploadLink(model).subscribe(result => {

            const data = {
              link: result.url,
              title: 'Internal uploadlink for Docs',
              // text: "Are you sure you want to send a new upload link (incl. invoice)? Other active links will be deactivated!"
              text: 'Click the link below to upload files.',

            };

            this.dialog.open(ShowDialogWithLinkComponent, {
              data
            }).afterClosed()
              .subscribe(dlgResult => {
                this.refreshCustomer();
              });

            this.snackBar.open('internal uploadlink created.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });
        }
      });




  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  currentUserIsAdminOrManager(): boolean {
 return this.roleService.hasRoles([ 'admin', 'manager', 'compliance' ] );
}
  currentUserIsAdminOrManagerOrAgent(): boolean {
 return this.roleService.hasRoles([ 'admin', 'manager', 'agent', 'compliance' ] );
}



  isIdvDisabled(customer: Customer){
    if ( customer.archived ) {
return true;
}

    // , "manager", "compliance"
    if ( !this.roleService.hasRoles(['admin']) ) {
return true;
}

    return false;
  }

  isDocsDisabled(customer: Customer){
    if ( customer.archived ) {
return true;
}

    if ( !this.roleService.hasRoles(['admin', 'manager', 'partner', 'compliance']) ) {
return true;
}


    return false;
  }

  isSofGenericDisabled(customer: Customer){
    if ( customer.archived ) {
return true;
}

    if ( !this.roleService.hasRoles(['admin', 'manager', 'partner', 'compliance']) ) {
return true;
}


    return false;
  }

  currentUserIsAdminOrCompliance(): boolean {
    return this.roleService.hasRoles(['admin', 'compliance']);
  }

  currentUserIsAdminOrComplianceOrManager(): boolean {
    return this.roleService.hasRoles(['admin', 'compliance', 'manager']);
  }

  isDocsResendUploadLinkDisabled = true;

  refreshDocsResendUploadLinkDisabled(){

    if ( !this.roleService.hasRoles(['admin', 'manager', 'partner', 'compliance']) ) {
      this.isDocsResendUploadLinkDisabled = true;
      return;
    }

    if( this.docInvoice != null && this.docInvoice.billAmount > this.docInvoice.paidAmount ) {
      this.isDocsResendUploadLinkDisabled = true;
      return;
    }

    this.isDocsResendUploadLinkDisabled = false;
  }

  resendDocsPaymentLink(customer: Customer){
    const data = {
      email: customer.email,
      title: 'Resend payment link for Docs ',
      text: 'Are you sure you want to resend the paymenlink?'
    };

    this.dialog.open(SendUploadLinkDialogComponent,{
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {

          this.customersService.resendDocPaymentLink(this.docsInvoiceId).subscribe(result => {
            this.snackBar.open('Payment link sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });

        }
      });
  }




  showMessage(msg) {
    this.snackBar.open( msg, null, {
      duration: 5000,
      panelClass: [ 'app-mat-snack-bar' ]
    } );
  }

  returnBack() {
    this.location.back();
  }

  openFile(fileId: number) {
    this.customersService.getFileInline( fileId ).subscribe(
      result => {

        const disposition = result.headers.get('Content-Disposition');
        const contentType = result.headers.get('Content-Type');
        const filename = disposition.split(';')[1].trim().split('=')[1];

        const blob = new Blob([result.body], { type: contentType });
        //FileSaver.saveAs(blob , filename);
        const fileURL = URL.createObjectURL(blob);


        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

        if( contentType.indexOf('image') >= 0){
          this.isImgHidden = false;
          this.isFrameHidden = true;

        }else{
          this.isImgHidden = true;
          this.isFrameHidden = false;

        }
        this.errorMsg = null;
        this.filename = filename;





        //FileHelper.saveFile( result );
      },
      err =>{
        this.filename = null;
        this.isImgHidden = true;
        this.isFrameHidden = true;
        this.errorMsg = 'Error occured during downloading the file.';

        this.snackBar.open( err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: [ 'app-mat-snack-bar' ]
        } );
      }

    );
  }

  downloadFile(fileId: number) {
    this.customersService.getFile( fileId ).subscribe(
      result => {
        FileHelper.saveFile( result );
      },
      err =>
        this.snackBar.open( err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: [ 'app-mat-snack-bar' ]
        } )
    );
  }

  isSaveIdvDisabled = true;
  isSaveDocsDisabled = true;
  isSaveSofSingleDisabled = true;
  isSaveSofGenericDisabled = true;

  refreshCustomer() {

    this.loadComments();

    this.refreshResendDocButton();

    this.isSaveIdvDisabled = true;
    this.isSaveDocsDisabled = true;

    this.customersService.get( this.customerId ).subscribe( data => {
      this.customer = data;
      if ( this.customer.ipAddress ) {
this.geoIpService.getCityByIp(this.customer.ipAddress).subscribe(city => this.ipCityInfo = city, err => {});
}

      this.newIdvLevelSelect = this.customer.identLevel;
      this.orders = data.orders;

      this.customersService.getOnlyIdv(this.customerId).subscribe(data => {

        this.idvUploadFiles = data;

        this.idvUploadFiles.forEach(file => {
          if (file.mailSentDate == null) {
            this.isSaveIdvDisabled = false;
          }

          if( !this.roleService.hasRoles(['admin', 'compliance']) ){
            this.isSaveIdvDisabled = true;
          }

        });


      });

      this.idvCustomersService.getLastLinkToken(this.customerId, 2).subscribe(data => {
        this.lastDocLinkToken = data;
      });

      this.idvCustomersService.getLastLinkToken(this.customerId, 4).subscribe(data => {
        this.lastSofGenericLinkToken = data;
      });

      this.customersService.getOnlyDocs(this.customerId).subscribe(data => {

        this.docsUploadFiles = data;

        this.docsUploadFiles.forEach(file => {
          if (file.mailSentDate == null) {
            this.isSaveDocsDisabled = false;
          }

          if( !this.roleService.hasRoles(['admin', 'compliance', 'finance_manager']) ){
            this.isSaveDocsDisabled = true;
          }
        });

      });

      this.customersService.getOnlySofSingle(this.customerId).subscribe(data => {
        this.sofSingleUploadFiles = data;
        this.sofSingleUploadFiles.forEach(file => {
          if (file.mailSentDate == null) {
            this.isSaveSofSingleDisabled = false;
          }

          if( !this.roleService.hasRoles(['admin', 'compliance', 'finance_manager']) ){
            this.isSaveSofSingleDisabled = true;
          }
        });
      });

      this.customersService.getOnlySofGeneric(this.customerId).subscribe(data => {
        this.sofGenericUploadFiles = data;
        this.sofGenericUploadFiles.forEach(file => {
          if (file.mailSentDate == null) {
            this.isSaveSofGenericDisabled = false;
          }
          if( !this.roleService.hasRoles(['admin', 'compliance', 'finance_manager']) ){
            this.isSaveSofGenericDisabled = true;
          }
        });
      });



      this.loadOpenBankTransferLoads();

    });





  }




  getOrdersTableFilters() {
    const a = getTableFilters('customerTable');
    return a;
  }

  getPrevNext(id: number) {
    const filters = this.getOrdersTableFilters();
    this.idvCustomersService.getPrevNext(filters, id).subscribe(result => {
      this.prevNext = result;
    });
  }

  gotoPrevCustomer() {
    const filters = this.getOrdersTableFilters();
    this.idvCustomersService.getPrev(filters, this.customerId).subscribe(result => {
      this.router.navigate(['..', result], { relativeTo: this.route });
    });
  }

  gotoNextCustomer() {
    const filters = this.getOrdersTableFilters();
    this.idvCustomersService.getNext(filters, this.customerId).subscribe(result => {
      this.router.navigate(['..', result], { relativeTo: this.route });
    });
  }

  clearData() {
    this.prevNext = null;
  }

  sendIdvLink(customer: Customer){
    this.dialog.open(SendUploadLinkDialogComponent,{
      data:{
        email: customer.email,
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {
          dlgResult.customerId = customer.id;
          dlgResult.typeId = 1;

          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this.snackBar.open('Uploadlink sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });

          this.refreshCustomer();


        }
      });
  }

  sendDocsLink(customer: Customer){

    const data = {
      email: customer.email,
      title: 'Send an uploadlink for Docs',
      // text: "Are you sure you want to send a new upload link (incl. invoice)? Other active links will be deactivated!"
      text: 'Are you sure you want to send a new upload link? Other active links will be deactivated!'
    };



    this.dialog.open(SendUploadLinkDialogComponent,{
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {
          dlgResult.customerId = customer.id;
          dlgResult.typeId = 2;

          // Anton 26.09.2021 doc link for free
          /*
          this.customersService.sendDocPaymentLink(dlgResult).subscribe(result => {
            this.snackBar.open("Paymentlink sent.", null, {
              duration: 5000,
              panelClass: ["app-mat-snack-bar"]
            });
            this.refreshResendDocButton();
          });
          */
          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this.snackBar.open('Uploadlink sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });


          this.refreshCustomer();
        }
      });
  }

  sendSofGenericLink(customer: Customer){

    const data = {
      email: customer.email,
      title: 'Request Source of Funds from customer',
      // text: "Are you sure you want to send a new upload link (incl. invoice)? Other active links will be deactivated!"
      text: 'Are you sure you want to send a new upload link? Other active links will be deactivated!'
    };



    this.dialog.open(SendUploadLinkDialogComponent,{
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {
          dlgResult.customerId = customer.id;
          dlgResult.typeId = 4; // sof generic


          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this._toastService.info('Request for SOF sent');
          });


          this.refreshCustomer();
        }
      });
  }


  docsInvoiceId;
  docInvoice;
  isDocLinkActive = false;
  docPaidText = '';
  isDocsResendHidden = true;

  refreshResendDocButton(){
    this.customersService.getIsAnyDocUploadActive(this.customerId).subscribe(data => {

      this.docPaidText = '';

      if(data != null) {
        this.isDocsResendHidden = false;
        if(data.docInvoice != null){

          this.isDocLinkActive = data.isActive;
          this.docsInvoiceId = data.docInvoice.id;
          this.docInvoice = data.docInvoice;
          if( data.docInvoice.billAmount <= data.docInvoice.paidAmount ){
            this.docPaidText = '(paid)';
          }else{
            this.docPaidText = '(NOT paid)';
          }

        }
      } else {

        // check if inactive paid link exists
        this.customersService.getIsAnyDocUploadInvoicePaid(this.customerId).subscribe(data => {

          if (data?.docInvoice != null) {
            this.isDocsResendHidden = false;
            this.docsInvoiceId = data.docInvoice.id;
            this.docInvoice = data.docInvoice;
            if (data.docInvoice.billAmount <= data.docInvoice.paidAmount) {
              this.docPaidText = '(paid)';
            } else {
              this.docPaidText = '(NOT paid)';
            }
          }else{
            this.isDocsResendHidden = true;
            this.docPaidText = '';
          }
        });

        this.refreshDocsResendUploadLinkDisabled();
      }

      this.refreshDocsResendUploadLinkDisabled();

    });
  }

  resendDocsInvoice(customer: Customer){
    const data = {
      email: customer.email,
      title: 'Resend invoice for Docs ',
      text: 'Are you sure you want to resend the paymenlink with invoice attached?'
    };

    this.dialog.open(SendUploadLinkDialogComponent,{
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {

          this.customersService.resendDocInvoice(this.docsInvoiceId).subscribe(result => {
            this.snackBar.open('Invoice sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });

        }
      });
  }

  resendDocsLink(customer: Customer){

    const data = {
      email: customer.email,
      title: 'Resend uploadlink for Docs '+this.docPaidText,
      text: 'Are you sure you want to resend the existing upload link?'
    };

    this.dialog.open(SendUploadLinkDialogComponent,{
      data
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {

          this.customersService.resendDocUploadLink(this.docsInvoiceId).subscribe(result => {
            this.snackBar.open('Link sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });
          /*
          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this.snackBar.open("Uploadlink sent.", null, {
              duration: 5000,
              panelClass: ["app-mat-snack-bar"]
            });
          });
          */

          this.refreshCustomer();
        }
      });
  }

  save( files: IdvUploadDto[] ){


    const t: IdvUploadDto[] = [];
    files.forEach(function(f) {
      if(f.mailSentDate == null){
        t.push(f);
      }
    });

    let isOk = true;
    let type: number;

    t.forEach(function(file) {
      if(file.isSuccess == null){
        isOk = false;
      }
      type = file.typId;
    });
    if(!isOk){
      alert('Not all documents are marked/reviewed.');
      return;
    }

    let isSuccess = null;
    let dialogTitle = '';

    // IDV
    if(type == 1){
      if(this.customer.idvSuccess == null) {
        alert('Please set the IDV status of the customer to success or failed.');
        return;
      }
      isSuccess = this.customer.idvSuccess;
    }
    // docs
    else if(type == 2 || type == 4){
      if(this.customer.docsSuccess == null) {
        alert('Please set the Docs status of the customer to success or failed.');
        return;
      }
      isSuccess = this.customer.docsSuccess;
    }

    const dialogStatusName = isSuccess ? 'Success' : 'Failed';
    dialogTitle = 'Send "'+dialogStatusName+'" to Customer?';

    this.dialog.open(ConfirmDialogComponent,{
      data:{
        title: dialogTitle,
        text:'Are you sure you want to save and send a message to the customer?',
        confirm: 'Ok',
        cancel: 'Cancel'
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult == 'ok') {




          this.idvCustomersService.saveIdvFiles(t).subscribe(result => {

            const requestItem = new CustomerIdvDocsStatusDto();
            requestItem.customerId = this.customer.id;
            requestItem.isSuccess = isSuccess;
            requestItem.typeId = type;
            requestItem.files = result;

            this.idvCustomersService.saveCustomerStatusAndSendEmail(requestItem).subscribe(result => {
              this._toastService.success('Saved and E-mail sent');
              this.refreshCustomer();
              this.badgeService.refreshBadge('compliance');
            });



          });

        }
      });


  }

  goToSofSingleDetail(btlId: number) {
    this.router.navigate(['../../sof/btl-detail/' + btlId], { relativeTo: this.route });
  }

  goToSofGenericDetail(customerId: number) {
    this.router.navigate(['../../sof/generic-detail/' + customerId], { relativeTo: this.route });
  }

  approveBankTransferLoadDocs(btlId: number) {
    this.customersService.approveBankTransferLoadDocs(btlId).subscribe(btl => {
      this.loadOpenBankTransferLoads();
    });
  }

  private loadOpenBankTransferLoads() {
    this.customersService.getOnlyOpenBankTransferLoads(this.customerId).subscribe(data => {

      this.openBankTransferLoads = data;

    });
  }



  // Upload
  filesDocs: File[] = [];
  filesSofGeneric: File[] = [];
  disabled = false;
  showUploadError = false;
  isUploading = false;
  lastDocLinkToken: string|null = null;
  lastSofGenericLinkToken: string|null = null;
  newIdvLevelSelect: IdentLevel|null;
  public identLevel = IdentLevel;
  public ohByNumeric = byNumeric;


  onSelectDocs(event) {
    this.filesDocs.push(...event.addedFiles);
  }

  onSelectSofGeneric(event) {
    this.filesSofGeneric.push(...event.addedFiles);
  }

  uploadToSofGeneric() {
    this.showUploadError = false;
    this.isUploading = true;
    this.disabled = true;


    const formData = new FormData();

    if (this.filesSofGeneric.length > 0) {
      // other files
      for (let i = 0; i < this.filesSofGeneric.length; i++) {
        formData.append('file[]', this.filesSofGeneric[i]);
        formData.append('docTypes[]', '0');

      }
    }



    this.idvCustomersService.uploadFiles(this.lastSofGenericLinkToken, formData).subscribe(result => {
        if (result) {
          this.isUploading = false;
          this.disabled = true;
          this.showUploadError = false;
          this.filesSofGeneric = [];
          this.refreshCustomer();
        }
      },
      error => {
        this.showUploadError = true;
        this.isUploading = false;
        this.disabled = false;
      });

  }

  uploadToDocs() {

    this.showUploadError = false;
    this.isUploading = true;
    this.disabled = true;


    const formData = new FormData();

    if (this.filesDocs.length > 0) {
      // other files
      for (let i = 0; i < this.filesDocs.length; i++) {
        formData.append('file[]', this.filesDocs[i]);
        formData.append('docTypes[]', '0');

      }
    }



    this.idvCustomersService.uploadFiles(this.lastDocLinkToken, formData).subscribe(result => {
        if (result) {
          this.isUploading = false;
          this.disabled = true;
          this.showUploadError = false;
          this.filesDocs = [];
          this.refreshCustomer();
        }
      },
      error => {
        this.showUploadError = true;
        this.isUploading = false;
        this.disabled = false;
      });

  }

  onRemoveDocs(event) {
    //console.log(event);
    this.filesDocs.splice(this.filesDocs.indexOf(event), 1);
  }

  onRemoveSofGeneric(event) {
    //console.log(event);
    this.filesSofGeneric.splice(this.filesSofGeneric.indexOf(event), 1);
  }

  setCustomerIdLevel(newIdvLevelSelect: IdentLevel) {
    this.customersService.setIdentLevel(this.customer, this.newIdvLevelSelect).subscribe(
      data => {
        this._toastService.success('New Ident Level has been set');
        this.customer.identLevel = this.newIdvLevelSelect;
        this.loadComments();
      }, err => {
        this._toastService.error('Error setting new Ident Level: ' + err);
      }
    );
  }

  private loadComments() {
    this.objectCommentsService.getForObject(this.customerId, this.commentsTarget).subscribe(data => {
      this.comments = data;
    });
  }

  getSofTypeName(typName: string) {
    if ( typName == "SOFGENERIC")
      return "SOF generic";
    if ( typName == "SOFSINGLE")
      return "SOF single";

    return typName;
  }
}
